import React from 'react';
import { Projectile as StyledProjectile } from '../styles/StyledComponents';
import { Projectile as ProjectileType } from '../hooks/useGame';

interface ProjectileProps {
  projectile: ProjectileType;
}

const Projectile: React.FC<ProjectileProps> = ({ projectile }) => {
  return (
    <StyledProjectile 
      position={projectile.position} 
    />
  );
};

export default Projectile;
